export enum UserCapacity {
  Manager = 'Gérant',
  President = 'Président',
  GeneralDirector = 'Directeur général',
  Independent = 'Indépendant',
  Employee = 'Salarié',
  Other = 'Autres'
}
